import { z } from 'zod';

const photoPathSchema = z
  .string()
  .regex(/^\//, 'photo path must start with /');

export const TeamBioSchema = z.object({
  name: z.string().min(1, 'name is required'),
  role: z.string().min(1, 'role is required'),
  // Optional array of photo paths — each must start with '/' so it resolves
  // from public/. Photos render stacked top-to-bottom in the bio card.
  photos: z.array(photoPathSchema).optional(),
  // Bio text. Paragraphs are separated by blank lines (\n\n) and the
  // component splits on that for rendering.
  bio: z.string().min(1, 'bio is required'),
});

export type TeamBio = z.infer<typeof TeamBioSchema>;
export const TeamBiosSchema = z.array(TeamBioSchema);
